import api from '@api'
import { transformAssetCustomRules } from '@modules/custom-rules/custom-rules-api'

export const transformRequiredNoteRules = (rule) => {
  const ruleInfo = {}

  if (rule.rulePropInfo) {
    for (const item of rule.rulePropInfo) {
      ruleInfo[item.propKey] = item.refIds
    }
  }

  return {
    id: rule.id,
    parentId: rule.refId,
    items: (rule.propKeysForNotes || []).concat(rule.customfieldForNotes || []),
    ruleInfo,
  }
}
export const transformDialogRules = (rule) => {
  const ruleInfo = {}

  // Populate ruleInfo using a simple loop
  if (rule.rulePropInfo) {
    for (const item of rule.rulePropInfo) {
      ruleInfo[item.propKey] = item.refIds
    }
  }

  return {
    id: rule.id,
    parentId: rule.refId,
    items: (rule.propKeysForDialog || []).concat(
      rule.customfieldForDialog || []
    ),
    ruleInfo,
  }
}

export const transformWorklogRules = (rule) => {
  return {
    id: rule.id,
    item: rule.managedKey || '',
  }
}

export function requiredNoteRulesApi(moduleName, _, parentId) {
  return api
    .get(`/${moduleName}/requirednoterule`, {
      params: {
        refId: parentId,
      },
    })
    .then(transformRequiredNoteRules)
}

export function dialogRulesApi(moduleName, _, parentId) {
  return api
    .get(`/${moduleName}/showdialogrule`, {
      params: {
        refId: parentId,
      },
    })
    .then(transformDialogRules)
}
export function worklogRulesApi(moduleName) {
  return api.get(`/${moduleName}/worklogrule`).then(transformWorklogRules)
}

export function assetCustomRulesApi() {
  return api.get('/asset/customrule').then((data) => {
    return transformAssetCustomRules(data)
  })
}
